export default {
    xboot: 'XBoot is a very good one-stop front-end and back-end separation rapid development platform',
    usernameLogin: 'Username Sign in',
    mobileLogin: 'Phone',
    autoLogin: 'Auto Login',
    forgetPass: 'Forget Password',
    otherLogin: 'Sign in with',
    regist: 'Register',
    register: "Register",
    registering: "Registering...",
    registerNow: "No account yet��Register now",
    loginNow: "Sign in with an account",
    login: 'Нэвтрэх',
    logining: 'Навтарч байгаа',
    ocr: "Өсөг бичгийг ялган таних",
    home: 'home',
    switchLangTitle: 'Switch Lang',
    international: 'Switch Lang',
    userCenter: 'Хувь хүмүүний дөв',
    changePass: 'Modify Pass',
    logOut: 'Sign out',
    tagOption: 'Labels',
    closeAll: 'Close All',
    closeOthers: 'Close Others',
    help: 'Help',
    privacy: 'Privacy',
    terms: 'Terms',
    rights: 'All Rights Reserved',
    sso: "XBoot Authentication Platform",
    authorize: "Authorize",
    authorizeAndSignin: "Authorize and Sign in",
    authorizing: "Authorizing...",
    wants: "wants to access your account",
    wants2: "",
    authAquire: "Public data only",
    aquireInfo: "Limited access to your public data",
    afterAuth: "Authorizing will redirect to",
    relateTitle: "Bind XBoot's Account",
    relate: "Bind",
    relating: "Binding...",
    textbtn: "Текст",
    docbtn: "Документ",
    automaticDetection: "Автомат",
    standard: "Юникод 2010",
    newstandard: "Юникод 2022(Батлаагүй)",
    menkcode: "Мөнхгал код ",
    translateSwitch: "Үгсийн орчуулга",
    translateOpen: "on",
    translateClose: "off",
    asr: "Дуут оролт",
    copy: "Хуулах",
    ononproduct: "Бусад үйлчилгээ",
    share: "Хуваалцах дээр дарна уу",
    onondoc: "Онон Док",
    ononoffice: "Онон Офис",
    ononmap: "Онон газрын зураг",
    en: "Англи хэл",
    zh: "Хятад хэл",
    kiril: "Кирилл",
    ononime: "Онон монгол бичгийн гар",
    auxiliaryTranslation: "Туслах орчуулга",
    mt: "Онон Машин орчуулга",
    ononfont: "Онон фонт",
    onondic: "Нээлттэй толь бичиг",
    mnconvert: "Монгол хэлний хувиргах",
    selectcode: "Код сонгоно уу",
    targetcode: "Зорилтот текстийн кодчилолын төрлийг сонгоно уу",
    platformnameforcodeconvert: "Код хувиргах",
    platformnamefortranslate: "Онон орчуулга",
    platformnameforconvert: "Кирилл-Монгол хөрвүүлэгч",
    historybtn: "Түүх",
    historyview: "DLKCKLSJL",
    historynull: "түүх байхгүй",
    historyremoveall: "Бүх түүхийг арилгасан",
    historyremoveforcurrent: "Одоогийн түүхээс хасагдсан",
    backtop: "Дээд тал руу буцах",
    resultXm: "Зөв глиф",
    resultErr: "Алдаа",
    clear: "Устгах",
    transtip: "Delimitation translation is enabled by default. If you don't need this function, please turn it off by yourself",
    accuracy: "Оновчтой байдлын үнэлгэ",
    shape: "Глиф",
    sound: "Код",
    dlhcode: "Дэлхий код",
    convertok: "Хөрвүүлэлт",
    debounceinfo: "Хөрвүүлэх/орчуулах товчыг дарснаас хойш 2.5 сэкундын дараа үйлдэл хийгдэх болно.",
    debouncetitle: "Хөрвүүлэлтийн зөвлөмжийг хойшлуулсан",
    logout: "Гарах",
    favorites: "favorites",
    defaultObjSelectedName: "сонгоно уу",
    placholder: "Хөрвүүлэхийн тулд эх текстийг оруулна уу ...",
    ononTrans: "Translate",
    ononConvert: "Convert",
    guideicon: "хөтөч",
    clearhistory: "тодорхой түүх",
    nohistory: "түүх байхгүй",
    uploadtip: "Документ сонгоно уу",
    uploadsuffix: ".doc, .docx файл байршуулна уу",
    historygetdata: "Зөвхөн сүүлийн 30 бичлэгийг хадгал",
    step1: "Хөрвүүлэхэд бэлэн байна",
    step2: "Кодчилолын төрлийг шалгана уу",
    step3: "Хөрвүүлэлт хийгдэж байнй",
    step4: "Дууссан",
    step_trans_1: "орчуулах бэлэн байна",
    step_trans_2: "Орчуулга явагдаж байна",
    step_trans_3: "Орчуулга дууссан",
    company: "Өвөр Монголын Онон Технологи ХХК",



    tzh: "Хятад",
    ten: "Англи",
    mo: "Уламжлалт монгол",
    mobz: "Уламжлалт монгол (Юникод 2010)",
    momkl: "Уламжлалт монгол（Мөнхгал код）",
    momw: "Уламжлалт монгол（Юникод 2022(Батлаагүй)）",
    selectlang: "Эх хэлийг сонгоно уу ",
    objlang: "Зорилтот хэлийг сонгоно уу ",
    transok: "орчуулга",
    transplacholder: "Танай орчуулах гэсэн өсгөө оруулаарай …",
    transplacholderNew: "Орчуулах эх бичвэрээ оруулна ууШинэ хэрэглэгч 5 удаа хэрэглэж болно...",
    resultplacholder: "орчуулга",

    convertplacholder: "Хөрвүүлэх текстийг оруулна уу ...",
    convertresultplacholder: "Текст хөрвүүлэх",
    convertmo: "Уламжлалт монгол",
    convertkiril: "Кирилл",

    allnewupdatetag: "Шинэ шинэчлэлт",

    codeconvert_select_outcode: "Гаралтын кодчилолыг сонгоно уу",
    codeconvert_sourcecode_outcode_eq_msg: "Оролтын болон гаралтын кодчилол нь адилхан тул өөр төрлийн кодчилол сонгоно уу",
    codeconvert_tips: "Хөрвүүлсэн ",


    copyd: "Хуулсан",
    copydfail: "Хуулбарлах ажиллагаа амжилтгүй боллоо. Гараар хуулна уу",
    copydnull: "Хуулах зүйл алга",
    serviceerr: "API алдаа",
    source_target_eq_msg: "Эх хэл нь зорилтот хэлээс өөр байх ёстой, дахин сонгоно уу!",

    site_convert_title: "Монгол хөрвүүлэлт-Монголын уламжлалт кирилл бичгийн солилцоо",
    site_code_convert_title: "Онон кодчилол хувиргах-Юникод、2022 оны түр зогсоол 、Менк код",
    site_translate_title: "Onon орчуулга-нарийлаг оноцтой өндөр бүтэмжтэй олон хэлний орчуулаагийн бааз",

    check_codeconvert_slected_tips: "Эх кодчилолын төрөл нь хамгийн сүүлд бүртгэгдсэн зорилтот кодчилолын төрөлтэй ижил байгаа нь илэрсэн бөгөөд зорилтот кодчилолын төрлийг таны хувьд автоматаар шинэчилсэн болно.",
    wxtips: "Зөвлөмж",

    placewait: "түр хүлээнэ үү",
    maxlimit: "Заасан тэмдэгтийн хязгаараас хэтэрсэн",
    proofread: "Залруулан харгуулагч",

    myTraffic: "Миний урсгалын хэмжээ",
    statisticalInformation: "Тоо бүртгэлийн мэдээ занги",
    orderManagement: "Захилаагийн хамааралт",
    noRealNameUser: "Гэрчлээдэй хэрэглэгч",
    ononbook: "Онон ном бичиг",
    ononLanguageResources: "Онон хэлний эх баялаг",
    MediaResourceManagementSystem: "融媒体资源管理系统",

    productCenter: "Бүтээгдэхүүний дөв",
    internetService: 'Сүлжээн үйлчилгээ',
    officeSoftware: 'Албан зөөлөн хэрэгсэл',
    languageIndustry: 'Хэлний аж үйлс',
    productSupport: 'Үйлдэхүүний дэмжлэг',
    aboutUs: 'Бидний тухай',
    followUs: 'Биднийг анхаараарай',
    ononCollege: 'Онон сургуули',
    userGuide: 'Хэрэглэх зүглүүр',
    audioBook: 'Дагалт сонсгол',
    qualificationHonor: 'Хир гэм яруу алдар',
    JoinUs: 'Бидэнтэй нэгдээрэй',
    mediaReports: 'Хэвлэл мэдээллийн тайлан',
    legalNotices: 'Хуули цаазын илэрхийлэлт',

    pleaseLogInToTranslate: 'Навтарсны дараа орчуулаарай',
    buy: 'Худалдан авах',
    invoiceManagement: "Баримтын хамааралт",

    myMembers: "Миний гишүүн",
    remainingFlow: "Үлдвэр урсгалын хэмжээ",
    maturity: "Хугацаа тулах",
    character: "Өсөг тэмдэг",
    frequency: "Хэрэглэх удаа",
    word: "Өсөг",

    autoDetection: "Авто байцаалт",
    unableToTecognizeLanguage: "Одоохны хэлний байцаалтыг дэмжихгүй, уламжлалт монгол хэл, хятад хэл, англи хэл оруулаарай",

    limitedExemption: 'Хязгаарт хэлтрүүлэлт',

    weChatGroup: "Вьцдийн бөлөг",
    technicalServices: "Мэргэжлийн үйлчилгээ",
    feedback: "Санал хүсэлт",

    PleasLogInToConvert: "Навтарсны дараа дахин хөрвүүлэх",
    loggedOut: "Навтарснаас гарав",

    realTimeTranslation: "Шууд орчуулах",
    paste: "Наах",
    clipboardIsEmpty: "Хайчилмалын хавтас хоосон байна",
    kindTips: "Санууламж",
    moreApplications: "Нэн олон хэрэглээн",
    free5: "Да сүйтгэл хураахгүйгээр хэрэглэх удаагаа нэгэнт хэрэглэж дууслаа, тэмдэглэсний дараа үргэлжлэн хэрэглээрэй ! <br> Шинэ хэрэглэгч данслуулахад төлбөр үгүйгээр 1500 өсгийг орчуулж болно .",
    openVip: "Гишүүн нгээгүү",
    ISee: "Жаа, мадлаа.",
    tts: "Ярианы синтез"
};